module.exports = __webpack_public_path__ + "static/media/datamachineBackground.a2bb3b86.svg";